import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import ColumnSearch from "./ColumnSearch"; // Seu componente de busca
import { BotoesAcoes } from "../styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { DataTypeReserva } from "../interfaces/DataTypeReserva"; // Sua interface de dados

import { getMenuItems } from "../constants/itemsActionColumns";

export const Columns = (
  // items: MenuProps["items"],
  reservaPeriodo: DataTypeReserva[], // Adicione as fontes de dados como parâmetros
  reservaSemPeriodo: DataTypeReserva[],
  periodoUsuarioId: number | null | undefined,
  onClick: (e: any) => void,
  setReservaId: (id: number) => void
): ColumnsType<DataTypeReserva> => {
  const items = getMenuItems(
    reservaPeriodo,
    reservaSemPeriodo,
    periodoUsuarioId
  ); // Gera os itens com base nas reservas
  return [
    {
      title: "Reserva id",
      dataIndex: "id",
      key: "id",
      width: "30%",
      ...ColumnSearch<DataTypeReserva>({ dataIndex: "id" }),
    },
    {
      title: "Reserva Ota",
      dataIndex: "idReservaOta",
      key: "idReservaOta",
      width: "30%",
      ...ColumnSearch<DataTypeReserva>({ dataIndex: "idReservaOta" }),
    },
    {
      title: "Data da Reserva",
      dataIndex: "dataReserva",
      key: "dataReserva",
      width: "30%",
      ...ColumnSearch<DataTypeReserva>({ dataIndex: "dataReserva" }),
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setReservaId(row.id);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
